<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :configuracaoFiltro="configuracaoFiltro"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :infoPrazos="infoPrazos",
    :pagina="filtro.pagina",
    :filtro="filtro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar"
  )
</template>

<script>
import { mapActions } from 'vuex'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalAvocar from '@/screens/analise/components/modal/AppModalAvocar'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel'
import AppModalAssinarTitulo from '@/screens/analise/components/AppModalAssinarTitulo'
import AppModalSolicitarRetificacao from '@/screens/analise/components/modal/AppModalSolicitarRetificacao'
const BaseFiltro = require('@/screens/analise/listagem/' + process.env.ESTADO + '/BaseFiltro').default
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  beforeRouteLeave (to, from, next) {
    if (to.name !== 'ordem-servico') {
      this.setProcessoSelecionados({ processos: [], map: true })
    }
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    AppModalAvocar,
    ModalTrocarResponsavel,
    AppModalAssinarTitulo,
    AppModalSolicitarRetificacao
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: {...FILTRO_EMPTY('CAIXA_ENTRADA_OS'), ordem: 'dataChegadaSetor', ordemDirecao: 'DESC'},
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      processosSelecionados: [],
      showModalResponsavel: false,
      showModalVisualizarProcesso: false,
      solicitarRetificacao: false,
      showModalAssinatura: false,
      showModalAvocar: false,
      processoTrocado: null,
      idProcesso: null,
      numeroProcesso: null,
      tipoProcesso: null,
      setorSelecionado: null,
      protocolo: null,
      idsProcessosAssinatura: [],
      idsProcessos: [],
      configuracaoFiltro: {
        filtroOrdemServico: filtro?.filtroOrdemServico?.INFORMACAO_SOLICITADA || [],
        filtroFuncao: filtro?.filtroFuncao?.INFORMACAO_SOLICITADA || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', marcado: () => false, ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 5, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 6, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [] },
        { id: 7, titulo: 'Ordem de Serviço', propriedade: 'numeroOs', ordem: 5, acoes: [], exibir: () => !this.isEstadoBA() },
        { id: 8, titulo: 'Função', propriedade: 'funcoes', ordem: 5, acoes: [] },
        { id: 9, titulo: 'Data de vencimento', propriedade: 'dataVencimento', ordem: 5, acoes: [], isPrazo: true, exibir: () => true },
        {
          id: 10, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Analisar Processo', icone: 'fa-file', codigo: 'ANALISAR_PROCESSO', ordem: 1, show: (row) => this.checkNotVistoria(row) },
            { id: 2, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: () => true }
          ]
        }
      ]
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  watch: {
    async '$route' (to, from) {
      this.initSubProcessos()
    }
  },
  methods: {
    ...mapActions({
      iniciaAnalise: 'subProcesso/iniciaAnalise',
      setProcessoSelecionados: 'ordemServico/setProcessoSelecionados'
    }),
    ANALISAR_PROCESSO: async (_this, { item }) => {
      await _this.iniciaAnalise(item)
      _this.$router.push({
        name: 'analise/analisar-validar-sub',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'ANALISE'
        }
      })
    },
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.processoId
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    checkNotVistoria (row) {
      return true
      // return !(row.funcoes === 'Vistoriador' && (row.codigoStatus === 'AGUARDANDO_ANALISE_VISTORIA' || row.codigoStatus === 'EM_REVISAO_VISTORIA'))
    },
    isEstadoBA () {
      return process.env.ESTADO === 'ba'
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaEntradaOrdemServico.vue